import ApartmentNumberColumns from "../../../LeadCompliance/components/Table/ApartmentNumberColumns";
import RedirectToClient from "../../../Tickets/components/RedirectToClient";
import MiceRats from "./MiceRats";
import Mold from "./Mold";
import Roaches from "./Roaches";
import ViewSurvey from "./ViewSurvey";
import { isAdmin, isSelfService } from "../../../../utils/helpers";
import DownloadUnitSurveyForm from "../../../LeadCompliance/components/Table/DownloadUnitSurveyForm";
import { downloadll55PendingMailer } from "../../../../sevices/ll55Api";

export const columns = [
  ...(isAdmin() ? [{
    field: "client",
    headerName: "Client",
    renderCell: (params) => {
      return <RedirectToClient params={params} />;
    },
    minWidth: 100,
    flex: 1.5,
    // editable: true,
    // sortable: false,
  },]:[]),
  {
    field: "building_address",
    headerName: "Building",
    renderCell: (params) => {
      return <p className="">{params.value}</p>;
    },
    minWidth: 110,
    flex: 1.5,
    // editable: true,
    // sortable: false,
  },

  {
    field: "unit_number",
    headerName: "Unit",
    renderCell: (params) => {
      return <ApartmentNumberColumns params={params} ll55={true} />;
    },
    minWidth: 100,
    flex: 0.7,
    // editable: true,
    // sortable: false,
  },
  {
    field: "mailer_count",
    headerName: "Mailers Send",
    renderCell: (params) => {
      return <p className="">{params.value}</p>;
    },
    minWidth: 100,
    flex: 1,
    // editable: true,
    sortable: false,
  },
  {
    field: "mold",
    headerName: "Mold",
    renderCell: (params) => {
      return <Mold params={params} />;
    },
    minWidth: 120,
    flex: 1.2,
    // editable: true,
    sortable: false,
  },
  {
    field: "roaches",
    headerName: "Roaches",
    renderCell: (params) => {
      return <Roaches params={params} />;
    },
    minWidth: 120,
    flex: 1.2,
    // editable: true,
    sortable: false,
  },
  {
    field: "mice_rats",
    headerName: "Mice/Rats",
    renderCell: (params) => {
      return <MiceRats params={params} />;
    },
    minWidth: 120,
    flex: 1.2,
    // editable: true,
    sortable: false,
  },
  {
    field: "survey",
    headerName: "Survey",
    renderCell: (params) => {
      const { building_id, unit_number, compliance } = params.row;
      const props = {
        unit_id: compliance.unit_id,
        building_id,
        unit_number,
        api: downloadll55PendingMailer,
        ll55: true,
      };
      return (
        <div className="w-100 d-flex justify-content-center">
          {compliance.status != "pending" && compliance.status ? (
            <ViewSurvey params={params} />
          ) : (
            (isAdmin() || isSelfService()) ? <DownloadUnitSurveyForm  {...props}/> : ''
          )}
        </div>
      );
    },
    renderHeader: (cell) => (
      <div className="w-100 d-flex justify-content-center">
        <p className="size-14 text-color weight-500">Survey</p>
      </div>
    ),
    minWidth: 110,
    flex: 0.8,
    // editable: true,
    sortable: false,
    headerClassName: "center-header ",
  },
];